import axios from "axios";

// Adjust the API_URL to point to your sales endpoint base if it's different
// For now, assuming it's under the same base URL as other admin portal APIs
const API_URL =
  import.meta.env.VITE_CRM_API_URL || "https://dashboard.lono.co.in/api/sales";
const BASE_URL = API_URL.replace('/sales', '');

// Helper function to get headers with token
// This might be useful if you decide to protect your sales data endpoint in the future
const getAuthHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  // Assuming admin or staff might access sales data, adjust token key if necessary
  const token =
    localStorage.getItem("adminToken") || localStorage.getItem("staffToken");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export const salesAPI = {
  // Get sales data metrics with optional filtering
  getSalesData: async (filters = {}) => {
    const { processingMethod, startDate, endDate, loanType, timeRange } = filters;
    const params = {};
    
    if (processingMethod) params.processingMethod = processingMethod;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (loanType) params.loanType = loanType;
    if (timeRange) params.timeRange = timeRange;
    
    const response = await axios.get(`${API_URL}/sales-data`, {
      headers: getAuthHeaders(),
      params
    });
    return response.data;
  },

  // Get admin sales data (total applications, pending, approved, trends)
  getAdminSalesData: async (filters = {}) => {
    const { timeRange } = filters;
    const params = {};
    
    if (timeRange) params.timeRange = timeRange;
    
    const response = await axios.get(`${API_URL}/admin`, {
      headers: getAuthHeaders(),
      params
    });
    return response.data;
  },
  
  // Lead source management
  getLeadSources: async () => {
    const response = await axios.get(`${API_URL}/lead-sources`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  
  addLeadSource: async (leadSourceData) => {
    const response = await axios.post(`${API_URL}/lead-sources`, leadSourceData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  
  // Platform fee tracking
  trackPlatformFee: async (feeData) => {
    const response = await axios.post(`${API_URL}/platform-fees`, feeData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
  
  // Seed test data
  seedData: async (count = 100) => {
    const response = await axios.post(`${BASE_URL}/seed/sales-data`, {}, {
      headers: getAuthHeaders(),
      params: { count }
    });
    return response.data;
  },
};